import angular from 'angular';
import moment from 'moment';

import templateUrl from './rogers-owner-payout-report-container.component.html';
import { containsInvariant, allContainsInvariant } from '../../../../../core/services/filter-util';
import { Booked } from '../../../../../core/enum/product-order-status-type';

export const RogersOwnerPayoutReportContainerComponent = {
    controller: RogersOwnerPayoutReportContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        identity: "<",
        hideOfficePayouts: '<?',
        hideRepPayouts: '<?',
        showLoggedInUserWorkOrders: '<?'
    }
};

function RogersOwnerPayoutReportContainerController($q, apexApiUrl, divisionService, icdCorporationService,
    rogersPayoutReportService, utilityService, workOrderService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;
    vm.icdCorporations;
    vm.onExport = onExport;
    vm.onRefreshData = onRefreshData;
    vm.showFilters = true;
    vm.workOrderPayouts;
    vm.productLines;
    vm.pageSize = 10;
    vm.pageNumber = 1;
    vm.onChangeFilter = onChangeFilter;
    vm.icdCorporationPageSize = 2000;
    vm.productOrderStatuses;
    vm.loaded = false;
    vm.statusDates = [
        { Name: "Pay Week Ending Date" },
        { Name: "Order Date" },
        { Name: "Appointment Date" },
        { Name: "Cancelled Date" },
        { Name: "Confirmed Date" },
        { Name: "Disconnected Date" }
    ];
    vm.salesChannels = [
        { Value: "DoorToDoor", Text: "D2D" },
        { Value: "Event", Text: "Event" },
        { Value: "Unknown", Text: "Unknown" }
    ];
    vm.filters = {
        StatusDate: vm.statusDates[0]
    };

    function onInit() {

        vm.filters.StartDate = moment().subtract(1, "week").startOf("day").toDate();
        vm.filters.EndDate = moment().startOf("day").toDate();

        const initialDataLoaded = loadInitialData();
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(initialDataLoaded, "Initial load failed"));
    }


    function onRefreshData() {
        vm.loaded = false;
        $q.when(utilityService.showLoading())
            .then(loadWorkOrderPayouts)
            .then(function (workOrders) {
                vm.workOrderPayouts = workOrders;
                vm.filteredWorkOrderPayouts = angular.copy(vm.workOrderPayouts)
                    .filter(filterWorkOrderPayout);
                calculateTotals();
                vm.loaded = true;
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(utilityService.hideLoading);

    }

    function onExport() {
        const query = createRogersPayoutReportQuery();
        const queryString = utilityService.queryStringify(query);
        window.location = apexApiUrl + "reports/rogers/owner-hybrid-payout-report.xlsx" + queryString;
    }

    function loadInitialData() {
        const icdCorporationsLoaded = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout", {
            divisionID: divisionService.divisionIDs.Rogers
        })
            .then(function (icdCorporations) {
                if (icdCorporations.length === 0) {
                    vm.showLoggedInUserWorkOrders = true
                    vm.hideOfficePayouts = true
                }

                vm.icdCorporations = icdCorporations;
                if (!vm.identity.IsSiteAdmin) {
                    vm.filters.IcdCorporation = icdCorporations[0]; // Not nullable.
                }
                vm.icdCorporations.forEach(formatIcdCorporation);
                vm.icdCorporations.sort(function (a, b) {
                    return a.OwnerClientName < b.OwnerClientName ? -1 : 1;
                });
                return icdCorporations;
            });

        const productOrderStatusesLoaded = workOrderService.retrieveProductOrderStatuses(
            divisionService.divisionIDs.Rogers)
            .then(function (statuses) {
                vm.productOrderStatuses = groupByProductOrderStatusType(statuses);
            })


        return $q.all([icdCorporationsLoaded, productOrderStatusesLoaded]);
    }

    function groupByProductOrderStatusType(statuses) {
        return statuses.reduce(function (result, status) {
            const existingStatus = result.filter(function (res) {
                return res.ProductOrderStatusType === status.ProductOrderStatusType;
            })[0];
            if (!existingStatus) {
                result.push({
                    ProductOrderStatusType: status.ProductOrderStatusType,
                    Name: status.ProductOrderStatusType === Booked.name
                        ? "Booked" : status.Name
                });
            }
            return result;
        }, []);
    }

    function loadWorkOrderPayouts() {
        const query = createRogersPayoutReportQuery();

        return rogersPayoutReportService.retrieveRogersOwnerHybridPayoutReport(query);
    }

    function formatIcdCorporation(icdCorporation) {
        icdCorporation.OwnerClientName = icdCorporation.Owner + " - " + icdCorporation.ClientName;
    }


    function calculateTotals() {
        vm.workOrderTotals = vm.filteredWorkOrderPayouts.reduce(function (totals, payout) {
            totals.OfficeBaseAmount += payout.OfficeBaseAmount;
            totals.OfficeMultiplayAmount += payout.OfficeMultiplayAmount;
            totals.OfficeContentAmount += payout.OfficeContentAmount;
            totals.OfficeTotalAmount += payout.OfficeTotalAmount;
            totals.RepBaseAmount += payout.RepBaseAmount;
            totals.RepMultiplayAmount += payout.RepMultiplayAmount;
            totals.RepContentAmount += payout.RepContentAmount;
            totals.RepTotalAmount += payout.RepTotalAmount;
            totals.OfficeInnovageRogersAdjustmentAmount += payout.OfficeInnovageRogersAdjustmentAmount;
            totals.RepInnovageRogersAdjustmentAmount += payout.RepInnovageRogersAdjustmentAmount;

            return totals;
        }, {
            OfficeBaseAmount: 0, OfficeMultiplayAmount: 0, OfficeContentAmount: 0, OfficeTotalAmount: 0,
            RepBaseAmount: 0, RepMultiplayAmount: 0, RepContentAmount: 0, RepTotalAmount: 0,
            OfficeInnovageRogersAdjustmentAmount: 0, RepInnovageRogersAdjustmentAmount: 0
        });
    }

    function onChangeFilter() {
        vm.filteredWorkOrderPayouts = angular.copy(vm.workOrderPayouts)
            .filter(filterWorkOrderPayout);
        calculateTotals();
    }

    function filterWorkOrderPayout(payout) {
        let employeeFullName = "";
        if (payout.Employee) {
            employeeFullName = payout.Employee.FirstName + " " + payout.Employee.LastName;
        }
        return allContainsInvariant(payout, vm.filters, [
            "SgiID",
            "CustomerFirstName",
            "CustomerLastName",
            "Address",
            "AccountNumber",
            "TypeOfPayout",
            "ProductCode",
            "ProductName",
            "ProductDescription",
            "OrderType",
            "ClientName",
            "WorkOrderNumber",
            "OwnerName",
            "MapAreaCode"
        ])
            && (!vm.filters.EmployeeName || containsInvariant(employeeFullName, vm.filters.EmployeeName))
            && (!vm.filters.StatusName || containsInvariant(payout.Status, vm.filters.StatusName))
            && (!vm.filters.OrderDate || moment(vm.filters.OrderDate).isSame(payout.OrderDate))
            && (!vm.filters.InstalledDate || moment(vm.filters.InstalledDate).isSame(payout.ConfirmedDate))
            && (!vm.filters.AppointmentDate || moment(vm.filters.AppointmentDate).isSame(payout.AppointmentDate))
            && (!vm.filters.CancelledDate || moment(vm.filters.CancelledDate).isSame(payout.CancelledDate))
            && (!vm.filters.DisconnectedDate || moment(vm.filters.DisconnectedDate).isSame(payout.DisconnectedDate))
            && (!vm.filters.PayWeekEndDate || moment(vm.filters.PayWeekEndDate).isSame(payout.PayWeekEndDate))
            && (!vm.filters.OriginalConnectDate || moment(vm.filters.OriginalConnectDate)
                .isSame(payout.OriginalConnectDate))
            && (!vm.filters.ProductLine || containsInvariant(payout.ProductLineName,
                vm.filters.ProductLine));
    }

    /**
     * Create a query object containing each property that can be sent as a parameter to the query.
     */
    function createRogersPayoutReportQuery() {
        const query = {
            DivisionID: divisionService.divisionIDs.Rogers,
            IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null,
            StartDate: vm.filters.StartDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.StartDate) : null,
            EndDate: vm.filters.EndDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.EndDate) : null,
            FilterByStatus: true,
            ShowAllWorkOrders: true,
            Status: vm.filters.Status ? vm.filters.Status.ProductOrderStatusType : null,
            ShowLoggedInUserWorkOrders: vm.showLoggedInUserWorkOrders,
            HideIntalledWorkOrders: vm.filters.hideInstalled,
            StatusName: vm.filters.StatusDate ? vm.filters.StatusDate.Name : ""
        };
        if (vm.filters.hidePosted) {
            query.showPosted = false;
        }
        if (vm.filters.salesChannel) {
            query.salesChannel = vm.filters.salesChannel.Value;
        }
        return query;
    }

}
